import event from '../../../utils/analytics/event';
/**
 * Custom hook that grants sharing functionality to twitter anywhere you need!
 *
 * By default, it logs 1 piwik event: `event(['share', 'twiter', <PAGE_BEING_SHARED>]);`, but you can pass in a custom `piwikEvent` to log instead.
 *
 * This event is logged when the user shares with Twitter. If choosing to continue with the default piwik events provided, a value must be provided for the `page` prop.
 *
 * If a value is passed for the `piwikEvent` prop, then the button onClick will log that custom event instead.
 *
 * Example usage:
 *
 * ```js
 * import { useTwitterShare } from '@minerva-analytics/pantheon';
 *
 * // Without custom piwik event
 * const Example = () => {
 *   const twitterShare = useTwitterShare(
 *     'Check out this awesome website!',
 *     'minervaanalytics.co',
 *   );
 *   return (
 *     <button onClick={() => twitterShare()}>
 *       Share via Twitter!
 *     </button>
 *   );
 * }
 *
 * // With custom piwik event
 * const Example = () => {
 *   const twitterShare = useTwitterShare(
 *     'Check out this awesome website!',
 *     'minervaanalytics.co',
 *     ['click', 'twitter-share']
 *   );
 *   return (
 *     <button onClick={() => twitterShare()}>
 *       Share via Twitter!
 *     </button>
 *   );
 * }
 * ```
 *
 * @param {string} body - Custom tweet body
 * @param {string} page - The page actually being shared
 * @param {array} piwikEvent - Optional custom event that is logged upon sharing with email. Must be an array in the form of `[category, action, name, value]`, though `name` and `value` are optional.
 *
 * @returns {function} - Function that allows user to share with Twitter
 */

var useTwitterShare = function useTwitterShare(body, page, piwikEvent) {
  if (piwikEvent === void 0) {
    piwikEvent = null;
  }

  var twitterShare = function twitterShare() {
    window.open("https://twitter.com/intent/tweet?text=" + body, "_blank");
    event(piwikEvent || ['share', 'twitter-start', page]);
  };

  return twitterShare;
};

export default useTwitterShare;